import { Component, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { userActions } from '@src/store/reducers/userReducer';

import * as _ from 'lodash';

export const types = {
    proj: 'project-icon',
    projectGroup: 'project-group-icon',
    user: 'user-icon',
    userGroup: 'users-icon'
};

@Component({
    selector: 'project-management',
    template: require('./project-management.component.html'),
    styles: [require('./project-management.component.scss')]
})
export class ProjectManagementComponent implements OnInit, OnDestroy {
    public project: any;
    public projectsAndGroups: any[];
    public usersAndGroups: any[];

    private unSubscribers: any[];

    constructor(private store: Store) {
    }

    public ngOnInit() {
        this.unSubscribers = [
            this.store.subscribe(() => {
                const projectsAndGroupsTemp = this.store.getState().user.projectsAndGroups;
                if (projectsAndGroupsTemp && projectsAndGroupsTemp.length > 0) {
                    this.projectsAndGroups = projectsAndGroupsTemp;
                }
                if (this.projectsAndGroups) {
                    this.projectsAndGroups.forEach((item: any) => {
                        item.icon = types[item.type];
                    });
                }
                this.projectsAndGroups = _.orderBy(this.projectsAndGroups, ['name'], ['asc']);
                this.projectsAndGroups = this.projectsAndGroups.filter(obj =>
                    !(obj.id === 1 && obj.type === "projectGroup")
                )
                this.usersAndGroups = this.store.getState().user.usersAndGroups;
                if (this.usersAndGroups) {
                    this.usersAndGroups.forEach((item: any) => {
                        item.icon = types[item.type];
                    });
                }
            })
        ];
        this.store.dispatch({ type: userActions.GET_PROJECT_AND_GROUPS });
    }

    public ngOnDestroy() {
        this.unSubscribers.forEach(us => us());
    }

    public getProjectUsersAndGroups(selectedItem: any) {
        this.project = selectedItem;
        const payload = { projectId: selectedItem.id };
        if (this.project.type === 'projectGroup') {
            this.store.dispatch({ payload, type: userActions.GET_USERS_AND_GROUPS_FOR_PROJCET_GROUP });
        } else {
            this.store.dispatch({ payload, type: userActions.GET_USERS_AND_GROUPS });
        }
    }

    public deleteProject() {
        this.store.dispatch({
            type: userActions.DELETE_PROJECT_GROUP,
            payload: { projectGroupId: this.project.id }
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/project-management/project-management.component.ts